import {
  decorate, observable, action, computed,
} from 'mobx';

class AppStore {
  constructor(stores) {
    this.stores = stores;
  }

  cityId = window.localStorage.cityId ? parseInt(window.localStorage.cityId, 10) : undefined;

  isShowLocationModal = false;

  menuOpenSectionName = undefined;

  alertText = undefined;

  alertTimeout = undefined;

  mapPlaceId = undefined;

  isOpenLeftMenu = false;

  status = 'pending';

  set city(newCity) {
    this.cityId = newCity.id;
    window.localStorage.cityId = newCity.id;
  }

  get country() {
    const { countries } = this.stores.CountryStore;
    return countries?.find((v) => v.cities.find(({ id }) => id === this.city.id));
  }

  get city() {
    const { countries } = this.stores.CountryStore;
    const cityId = this.cityId || this.stores.session?.user?.city || 1;
    return countries?.map(({ cities }) => cities).flat().find(({ id }) => id === cityId);
  }

  showLocationModal() {
    document.body.classList.add('hide--scroll');
    this.isShowLocationModal = true;
  }

  hideLocationModal() {
    document.body.classList.remove('hide--scroll');
    this.isShowLocationModal = false;
  }

  openLeftMenu() {
    document.body.classList.add('hide--scroll');
    this.isOpenLeftMenu = true;
  }

  closeLeftMenu() {
    document.body.classList.remove('hide--scroll');
    this.isOpenLeftMenu = false;
  }

  showAlert(text, time = 2000) {
    this.alertText = text;
    clearTimeout(this.alertTimeoutId);
    this.alertTimeout = setTimeout(() => {
      this.alertText = undefined;
    }, time);
  }
}

export default decorate(AppStore, {
  menuOpenSectionName: observable,
  alertText: observable,
  status: observable,
  isShowLocationModal: observable,
  cityId: observable,
  country: computed,
  city: computed,
  isOpenLeftMenu: observable,
  showAlert: action.bound,
  showLocationModal: action.bound,
  hideLocationModal: action.bound,
  openLeftMenu: action.bound,
  closeLeftMenu: action.bound,
});
